<div class="md:py-2 flex flex-col w-full px-2" #searchBox>
  <div class="flex flex-row items-center w-full gap-2">
    <!-- Search box moved to the right -->
    <img
      src="./assets/ai/ai-search-icon.png"
      class="-scale-x-100 md:block hidden w-12 h-12"
    />
    <sia-search-box
      class="flex-1"
      [aiSearch]="true"
      [surfaceClass]="'surface-lowest'"
      [hideSearchIcon]="true"
      [(searchExp)]="queryText"
      (searchClicked)="applyFilters()"
    >
    </sia-search-box>
    <button
      mat-flat-button
      (click)="applyFilters()"
      class="ai"
      [style.height.px]="40"
      [disabled]="!filterChanged()"
    >
      <div class="flex flex-row gap-2">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <linearGradient
              [id]="'movingAiGradient-' + id"
              x1="0%"
              y1="0%"
              x2="100%"
              y2="100%"
              gradientUnits="objectBoundingBox"
            >
              <stop offset="0%" stop-color="#d7d7d7" />
              <stop offset="50%" stop-color="#ffffff" />
              <stop offset="100%" stop-color="#d7d7d7" />
            </linearGradient>
          </defs>

          <g class="ai-stars-animated">
            <path
              d="M10 20C10 20 10.9572 15.0298 12.8715 13.1155C14.7858 11.2012 19.756 10.244 19.756 10.244C19.756 10.244 14.7858 9.28682 12.8715 7.37253C10.9572 5.45823 10 0.488037 10 0.488037C10 0.488037 9.04284 5.45823 7.12855 7.37253C5.21426 9.28682 0.244019 10.244 0.244019 10.244C0.244019 10.244 5.21426 11.2012 7.12855 13.1155C9.04284 15.0298 10 20 10 20Z"
              [attr.fill]="
                'url(' + svgUrlPrefix + '#movingAiGradient-' + id + ')'
              "
            />
            <path
              d="M19.5 24C19.5 24 19.8291 22.2915 20.4871 21.6335C21.1451 20.9755 22.8536 20.6464 22.8536 20.6464C22.8536 20.6464 21.1451 20.3174 20.4871 19.6593C19.8291 19.0013 19.5 17.2929 19.5 17.2929C19.5 17.2929 19.1709 19.0013 18.5129 19.6593C17.8549 20.3174 16.1464 20.6464 16.1464 20.6464C16.1464 20.6464 17.8549 20.9755 18.5129 21.6335C19.1709 22.2915 19.5 24 19.5 24Z"
              [attr.fill]="
                'url(' + svgUrlPrefix + '#movingAiGradient-' + id + ')'
              "
            />
            <path
              d="M21 5.85366C21 5.85366 21.1645 4.9994 21.4936 4.67041C21.8226 4.34141 22.6768 4.17688 22.6768 4.17688C22.6768 4.17688 21.8226 4.01235 21.4936 3.68335C21.1645 3.35436 21 2.5001 21 2.5001C21 2.5001 20.8355 3.35436 20.5064 3.68335C20.1774 4.01235 19.3232 4.17688 19.3232 4.17688C19.3232 4.17688 20.1774 4.34141 20.5064 4.67041C20.8355 4.9994 21 5.85366 21 5.85366Z"
              [attr.fill]="
                'url(' + svgUrlPrefix + '#movingAiGradient-' + id + ')'
              "
            />
          </g>
        </svg>
        Cerca
      </div>
    </button>
  </div>
  <div
    class="flex-nowrap md:flex-wrap flex flex-row gap-2 pt-2 overflow-x-auto overflow-y-visible"
  >
    <ng-container
      [ngTemplateOutlet]="chipFilterTemplate"
      [ngTemplateOutletContext]="{
        menuTrigger: categoryTreeMenu,
        tooltip:
          selectedCategoryIds().size > 0
            ? selectedCategoryIds().size +
              (' Categorie selezionate' | siaTranslate)
            : ('Tutte le categorie' | siaTranslate),
        icon: selectedCategoryIds().size > 0 ? 'filter_alt' : 'category',
        label:
          selectedCategoryIds().size > 0
            ? ('Categorie selezionate' | siaTranslate)
            : ('Tutte le categorie' | siaTranslate),
        filterText:
          selectedCategoryIds().size > 0 ? selectedCategoryIds().size : '',
        applied: selectedCategoryIds().size > 0,
      }"
    >
    </ng-container>
    @for (chip of filtersChips(); track $index) {
      <ng-container
        [ngTemplateOutlet]="chipFilterTemplate"
        [ngTemplateOutletContext]="{
          menuTrigger:
            chip.menuTriggerType == 'text'
              ? textFilterMenu
              : chip.menuTriggerType == 'date'
                ? dateFilterMenu
                : chip.menuTriggerType == 'array'
                  ? arrayFilterMenu
                  : categoryTreeMenu,
          tooltip: chip.tooltip,
          label: chip.label,
          filterText: chip.filterText,
          applied: chip.applied,
          menuData: chip.menuData,
        }"
      >
      </ng-container>
    }
    @for (chip of generalFilterChips(); track $index) {
      <ng-container
        [ngTemplateOutlet]="chipFilterTemplate"
        [ngTemplateOutletContext]="{
          menuTrigger:
            chip.menuTriggerType == 'text'
              ? textFilterMenu
              : chip.menuTriggerType == 'date'
                ? dateFilterMenu
                : chip.menuTriggerType == 'array'
                  ? arrayFilterMenu
                  : categoryTreeMenu,
          tooltip: chip.tooltip,
          label: chip.label,
          filterText: chip.filterText,
          applied: chip.applied,
          menuData: chip.menuData,
        }"
      >
      </ng-container>
    }
    <ng-container
      [ngTemplateOutlet]="chipFilterTemplate"
      [ngTemplateOutletContext]="{
        menuTrigger: keysFilterMenu,
        tooltip:
          selectedCategoryIds().size > 0
            ? 'Aggiungi filtro'
            : 'Devi selezionare almeno una categoria per aggiungere un filtro',
        label: 'Aggiungi filtro',
        disabled:
          selectedCategoryIds().size > 0 && keysAdditionalFilters().length > 0
            ? false
            : true,
        dropDownIcon: 'add_circle',
      }"
    >
    </ng-container>

    @for (chip of keysFilterChips(); track $index) {
      <ng-container
        [ngTemplateOutlet]="chipFilterTemplate"
        [ngTemplateOutletContext]="{
          menuTrigger:
            chip.menuTriggerType == 'text'
              ? textFilterMenu
              : chip.menuTriggerType == 'date'
                ? dateFilterMenu
                : chip.menuTriggerType == 'array'
                  ? arrayFilterMenu
                  : chip.menuTriggerType == 'number'
                    ? numberFilterMenu
                    : categoryTreeMenu,
          tooltip: chip.tooltip,
          label: chip.label,
          filterText: chip.filterText,
          applied: chip.applied,
          menuData: chip.menuData,
          category: chip.category,
        }"
      >
      </ng-container>
    }
    <ng-template
      #chipFilterTemplate
      let-menuTrigger="menuTrigger"
      let-aiFilter="aiFilter"
      let-tooltip="tooltip"
      let-label="label"
      let-applied="applied"
      let-filterText="filterText"
      let-icon="icon"
      let-dropDownIcon="dropDownIcon"
      let-menuData="menuData"
      let-disabled="disabled"
      let-category="category"
      let-inConflict="inConflict"
    >
      <div
        #menuTriggerRef="matMenuTrigger"
        [matMenuTriggerFor]="disabled ? null : menuTrigger"
        [matMenuTriggerData]="{
          filter: menuData?.filter,
          arrayDataSource: menuData?.arrayDataSource,
          trigger: menuTriggerRef,
          treeDataSource: menuData?.treeDataSource,
        }"
        (menuOpened)="loadDocumentationCategories()"
        class="relative flex min-w-fit cursor-pointer flex-nowrap items-center gap-2 rounded-lg border border-solid border-[var(--mat-sys-outline)] px-4 py-1"
        [siaTooltip]="tooltip"
        [class]="
          applied && !aiFilter
            ? 'bg-primary-container sia-hover border-hidden'
            : aiFilter
              ? '!border-[var(--ai-shade-1)]'
              : disabled
                ? 'sia-hover !cursor-not-allowed bg-[var(--mat-sys-outline-variant)] opacity-80'
                : ''
        "
      >
        @if (category) {
          <div
            class="surface absolute left-[8px] top-[-1px] h-[1px]"
            [style.width.px]="labelText.offsetWidth"
          ></div>
          <span
            class="text-primary absolute left-[8px] top-[-8px] max-w-[calc(100%-16px)] truncate px-1 text-xs font-semibold"
            [class]="aiFilter ? '!text-[var(--ai-shade-2)]' : ''"
            #labelText
          >
            {{ category }}
          </span>
        }
        @if (icon) {
          <mat-icon
            class="text-base"
            [class]="aiFilter ? '!text-[var(--ai-shade-2)]' : ''"
          >
            {{ icon }}
          </mat-icon>
        }
        <span
          class="text-sm text-[var(--mat-sys-on-surface-variant)]"
          [class]="aiFilter ? '!text-[var(--ai-shade-2)]' : ''"
          [class.line-through]="inConflict"
        >
          {{ label }}
          {{ filterText ? ': ' : '' }}
          <span class="font-semibold">{{ filterText }}</span>
        </span>
        @if (!filterText) {
          <mat-icon class="text-base">{{
            dropDownIcon || 'arrow_drop_down'
          }}</mat-icon>
        } @else if (!aiFilter && !inConflict) {
          <mat-icon
            class="text-base"
            [siaTooltip]="'Rimuovi filtro'"
            (click)="
              menuTrigger == categoryTreeMenu
                ? removeCategoryFilter()
                : removeFilter(menuData.filter, $event)
            "
          >
            close
          </mat-icon>
        } @else if (inConflict) {
          <mat-icon
            class="!text-[var(--ai-shade-2)]"
            [siaTooltip]="'Filtro in conflitto'"
          >
            warning
          </mat-icon>
        }
      </div>
    </ng-template>
  </div>
  @if (
    (aiFilterChips() && aiFilterChips()!.length > 0) ||
    (aiGeneratedFilters()?.categories &&
      aiGeneratedFilters()!.categories!.length > 0)
  ) {
    <div class="md:flex md:flex-wrap flex-row items-center hidden gap-2 pt-2">
      <span class="font-semibold text-[var(--ai-shade-2)]">
        {{ 'Kitsune ha rilevato:' | siaTranslate }}
      </span>
      <ng-container
        [ngTemplateOutlet]="chipFilterTemplate"
        [ngTemplateOutletContext]="{
          menuTrigger: aiCategoryTreeMenu,
          tooltip: 'Categorie selezionate' | siaTranslate,
          icon: 'filter_alt',
          label: 'Categorie selezionate' | siaTranslate,
          filterText: aiGeneratedFilters()!.categories!.length,
          aiFilter: true,
        }"
      >
      </ng-container>
      @for (chip of aiFilterChips(); track $index) {
        <ng-container
          [ngTemplateOutlet]="chipFilterTemplate"
          [ngTemplateOutletContext]="{
            menuTrigger: null,
            tooltip: chip.tooltip,
            aiFilter: true,
            label: chip.label,
            filterText: chip.filterText,
            applied: true,
            menuData: null,
            category: chip.category,
            inConflict: chip.inConflict,
          }"
        >
        </ng-container>
      }
      <button mat-flat-button class="ai" (click)="applyAIFilters()">
        {{ 'Imposta filtri AI' | siaTranslate }}
      </button>
    </div>
  }
  <!-- Category Tree Menu -->
  <mat-menu
    #categoryTreeMenu="matMenu"
    class="category-tree-menu !min-w-[300px] !max-w-[800px]"
  >
    <ng-template matMenuContent>
      <div
        class="h-full w-full min-w-[300px] p-4"
        (click)="$event.stopPropagation()"
      >
        <div
          class="mb-2 border-b border-solid border-[var(--mat-sys-outline-variant)] pb-2"
        >
          <div class="sia-hover flex items-center w-full py-1 rounded">
            <button
              mat-icon-button
              class="invisible !h-6 !w-6 !min-w-0 flex-shrink-0"
            ></button>
            <mat-checkbox
              [checked]="allCategoriesState().checked"
              [indeterminate]="allCategoriesState().indeterminate"
              (change)="toggleAllCategories($event)"
              (click)="$event.stopPropagation()"
              class="mr-2 scale-90"
            >
            </mat-checkbox>
            <span class="text-sm font-semibold">{{
              'Seleziona tutte' | siaTranslate
            }}</span>
          </div>
          <div class="sia-hover flex items-center w-full py-1 rounded">
            <button
              mat-icon-button
              class="invisible !h-6 !w-6 !min-w-0 flex-shrink-0"
            ></button>
            <mat-checkbox
              [checked]="isChecked('none-category')"
              (change)="toggleCategory('none-category')"
              (click)="$event.stopPropagation()"
              class="mr-2 scale-90"
            >
            </mat-checkbox>
            <mat-icon class="opacity-80 flex-shrink-0 mr-2 text-sm"
              >label_off</mat-icon
            >
            <span class="text-sm font-semibold">{{
              'Nessuna categoria assegnata' | siaTranslate
            }}</span>
          </div>
        </div>
        <div class="max-h-[400px] overflow-y-auto">
          <mat-tree
            [dataSource]="categoriesTreeDataSource"
            [treeControl]="treeControl"
          >
            <!-- Tree node template for parent nodes with children -->
            <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
              <div class="tree-node">
                <div
                  class="sia-hover flex items-center w-full py-1 rounded"
                  matTreeNodeToggle
                >
                  <!-- Expand/collapse button -->
                  <button
                    mat-icon-button
                    matTreeNodeToggle
                    class="!h-6 !w-6 !min-w-0 flex-shrink-0"
                  >
                    <mat-icon class="text-base">
                      {{
                        treeControl.isExpanded(node)
                          ? 'expand_more'
                          : 'chevron_right'
                      }}
                    </mat-icon>
                  </button>

                  <!-- Checkbox -->
                  <mat-checkbox
                    [checked]="allCategoryChildrenSelected()[node.id]"
                    [indeterminate]="indeterminateCategories()[node.id]"
                    (change)="toggleParentCategory(node, $event)"
                    (click)="$event.stopPropagation()"
                    class="mr-2 scale-90"
                  >
                  </mat-checkbox>

                  <!-- Icon and label -->
                  <mat-icon
                    class="flex-shrink-0 mr-2 text-sm"
                    [style.color]="node.color"
                  >
                    {{ node.icon }}
                  </mat-icon>
                  <span class="text-sm font-medium">{{
                    node.description | siaTranslate
                  }}</span>
                </div>

                <!-- Children container -->
                <div
                  [class.hidden]="!treeControl.isExpanded(node)"
                  class="ml-8"
                  role="group"
                >
                  <ng-container matTreeNodeOutlet></ng-container>
                </div>
              </div>
            </mat-nested-tree-node>

            <!-- Tree node template for leaf nodes (no children) -->
            <mat-tree-node
              *matTreeNodeDef="let node"
              class="sia-hover flex items-center w-full py-1 rounded"
            >
              <mat-checkbox
                [checked]="isChecked(node.id)"
                (change)="toggleCategory(node.id)"
                (click)="$event.stopPropagation()"
                class="mr-2 scale-90"
              >
              </mat-checkbox>
              @if (node.icon) {
                <mat-icon
                  class="flex-shrink-0 mr-2 text-sm"
                  [style.color]="node.color"
                >
                  {{ node.icon }}
                </mat-icon>
              }
              <span class="text-sm">{{ node.description | siaTranslate }}</span>
            </mat-tree-node>
          </mat-tree>
        </div>
      </div>
    </ng-template>
  </mat-menu>

  <!-- Ai categories Tree Menu -->
  <mat-menu
    #aiCategoryTreeMenu="matMenu"
    class="category-tree-menu !min-w-[300px] !max-w-[800px]"
  >
    <ng-template matMenuContent>
      <div
        class="relative h-full w-full min-w-[300px] p-4"
        (click)="$event.stopPropagation()"
      >
        <div class="absolute inset-0 z-10"></div>
        <div class="max-h-[400px] overflow-y-auto">
          <mat-tree
            [dataSource]="aiCategoriesTreeDataSource"
            [treeControl]="treeControl"
          >
            <!-- Tree node template for parent nodes with children -->
            <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
              <div class="tree-node">
                <div
                  class="sia-hover flex items-center w-full py-1 rounded"
                  matTreeNodeToggle
                >
                  <!-- Expand/collapse button -->
                  <button
                    mat-icon-button
                    matTreeNodeToggle
                    class="!h-6 !w-6 !min-w-0 flex-shrink-0"
                  >
                    <mat-icon class="text-base">
                      {{
                        treeControl.isExpanded(node)
                          ? 'expand_more'
                          : 'chevron_right'
                      }}
                    </mat-icon>
                  </button>

                  <!-- Checkbox -->
                  <mat-checkbox
                    [checked]="!node.indeterminate ? true : false"
                    [indeterminate]="node.indeterminate"
                    class="mr-2 scale-90"
                  >
                  </mat-checkbox>

                  <!-- Icon and label -->
                  <mat-icon
                    class="flex-shrink-0 mr-2 text-sm"
                    [style.color]="node.color"
                  >
                    {{ node.icon }}
                  </mat-icon>
                  <span class="text-sm font-medium">{{
                    node.description | siaTranslate
                  }}</span>
                </div>

                <!-- Children container -->
                <div
                  [class.hidden]="!treeControl.isExpanded(node)"
                  class="ml-8"
                  role="group"
                >
                  <ng-container matTreeNodeOutlet></ng-container>
                </div>
              </div>
            </mat-nested-tree-node>

            <!-- Tree node template for leaf nodes (no children) -->
            <mat-tree-node
              *matTreeNodeDef="let node"
              class="sia-hover flex items-center w-full py-1 rounded"
            >
              <mat-checkbox [checked]="true" class="mr-2 scale-90">
              </mat-checkbox>
              @if (node.icon) {
                <mat-icon
                  class="flex-shrink-0 mr-2 text-sm"
                  [style.color]="node.color"
                >
                  {{ node.icon }}
                </mat-icon>
              }
              <span class="text-sm">{{ node.description | siaTranslate }}</span>
            </mat-tree-node>
          </mat-tree>
        </div>
      </div>
    </ng-template>
  </mat-menu>

  <!-- Text Filter mat-menu -->
  <mat-menu #textFilterMenu="matMenu" (closed)="matMenuClosed($event)">
    <ng-template matMenuContent let-filter="filter" let-trigger="trigger">
      <div
        class="flex flex-row items-center gap-2 p-2"
        (click)="$event.stopPropagation()"
      >
        <button
          mat-icon-button
          #textOperatorTrigger="matMenuTrigger"
          [matMenuTriggerFor]="textOperatorMenu"
          [matMenuTriggerData]="{
            trigger: textOperatorTrigger,
          }"
          [siaTooltip]="
            getTextOperatorLabel(filter.textOperator) | siaTranslate
          "
          class="small"
        >
          <span [class]="getTextOperatorIcon(filter.textOperator)"></span>
        </button>
        <mat-menu #textOperatorMenu="matMenu">
          <ng-template matMenuContent let-operatorTrigger="trigger">
            @for (op of textOperators; track op.value) {
              <button
                mat-menu-item
                (click)="
                  setFilterTextOperator(
                    filter,
                    op.value,
                    $event,
                    operatorTrigger
                  )
                "
              >
                <span [class]="op.icon" class="mr-2"></span>
                <span>{{ op.label | siaTranslate }}</span>
              </button>
            }
          </ng-template>
        </mat-menu>
        <sia-text-box
          [label]="'Valore'"
          [(value)]="filter.textFilter"
          (enterPressed)="trigger?.closeMenu()"
          (valueChange)="setFilterTextValue(filter, $event)"
        ></sia-text-box>
      </div>
    </ng-template>
  </mat-menu>

  <!-- Number filter mat-menu -->
  <mat-menu #numberFilterMenu="matMenu" (closed)="matMenuClosed($event)">
    <ng-template matMenuContent let-filter="filter">
      <div
        class="flex flex-row items-center gap-2 p-2"
        (click)="$event.stopPropagation()"
      >
        <button
          mat-icon-button
          #operatorTrigger="matMenuTrigger"
          [matMenuTriggerFor]="operatorMenu"
          [matMenuTriggerData]="{
            trigger: operatorTrigger,
          }"
          [siaTooltip]="getOperatorLabel(filter.numberOperator) | siaTranslate"
          class="small"
        >
          <span [class]="getOperatorIcon(filter.numberOperator)"></span>
        </button>
        <mat-menu #operatorMenu="matMenu">
          <ng-template matMenuContent let-trigger="trigger">
            @for (op of numberOperators; track op.value) {
              <button
                mat-menu-item
                (click)="
                  setFilterNumberOperator(filter, op.value, $event, trigger)
                "
              >
                <span [class]="op.icon" class="mr-2"></span>
                <span>{{ op.label | siaTranslate }}</span>
              </button>
            }
          </ng-template>
        </mat-menu>
        <sia-number-box
          [label]="'Valore'"
          [(value)]="filter.numberFilter"
          (valueChange)="setFilterNumberValue(filter, $event)"
        ></sia-number-box>
      </div>
    </ng-template>
  </mat-menu>

  <!-- Date start end mat-menu -->
  <mat-menu #dateFilterMenu="matMenu" (closed)="matMenuClosed($event)">
    <ng-template matMenuContent let-filter="filter">
      <div class="flex flex-col gap-2 p-2" (click)="$event.stopPropagation()">
        <sia-datetime-box
          [label]="'Da'"
          [value]="filter.dateStart"
          (valueChange)="setFilterDateStartValue(filter, $event)"
        ></sia-datetime-box>
        <sia-datetime-box
          [label]="'A'"
          [value]="filter.dateEnd"
          (valueChange)="setFilterDateEndValue(filter, $event)"
        ></sia-datetime-box>
      </div>
    </ng-template>
  </mat-menu>
  <!-- Array Filter mat-menu -->
  <mat-menu #arrayFilterMenu="matMenu" (closed)="matMenuClosed($event)">
    <ng-template
      matMenuContent
      let-filter="filter"
      let-arrayDataSource="arrayDataSource"
    >
      <div class="flex flex-col p-2" (click)="$event.stopPropagation()">
        @if (arrayDataSource?.length > 10) {
          <div class="w-full px-1 mb-2">
            <sia-text-box
              [label]="'Cerca: ' | siaTranslate"
              [(value)]="filter.arraySearchText"
              (valueChange)="
                filter.arraySearchText = $event; updateSignalValues()
              "
            ></sia-text-box>
          </div>
        }
        <cdk-virtual-scroll-viewport itemSize="40" class="h-[300px] w-[260px]">
          <mat-checkbox
            *cdkVirtualFor="
              let item of getFilteredArrayDataSource(
                arrayDataSource,
                filter.arraySearchText
              )
            "
            [checked]="(filter.arrayFilter || []).includes(item.id)"
            class="w-full max-w-[250px] truncate"
            (change)="toggleArrayFilter(filter, item.id)"
          >
            {{ item.description | siaTranslate }}
          </mat-checkbox>
        </cdk-virtual-scroll-viewport>
      </div>
    </ng-template>
  </mat-menu>
  <!-- Additional filters mat-menu-->
  <mat-menu #keysFilterMenu="matMenu" (closed)="matMenuClosed($event)">
    <ng-template matMenuContent let-trigger="trigger">
      <div
        class="flex max-h-[200px] flex-col gap-1 overflow-auto p-2"
        (click)="$event.stopPropagation()"
      >
        @for (
          category of keysAdditionalFiltersByCategory();
          track $index;
          let first = $first
        ) {
          <div
            class="flex flex-row items-center justify-center w-full px-2 mb-1"
            [class.mt-1]="!first"
          >
            <span class="text-primary text-lg font-semibold truncate">
              {{ category.description | siaTranslate }}
            </span>
          </div>
          @for (item of category.keys; track $index) {
            <div class="flex flex-row items-center justify-between">
              <mat-checkbox
                [checked]="item.selected"
                (change)="selectAdditionalKeyFilter(item)"
                [style.width]="
                  'calc(100% - ' + iconContainer.offsetWidth + 'px)'
                "
              >
                <span class="font-medium truncate">
                  {{ item.description | siaTranslate }}
                </span>
              </mat-checkbox>
              <div class="flex items-center" #iconContainer>
                <mat-icon>
                  {{ item.typeIcon }}
                </mat-icon>
              </div>
            </div>
          }
        }
      </div>
    </ng-template>
  </mat-menu>
</div>
